import { Alert } from "cortex/ui/src/fleet/view/alert/model";
import { getApiReducer } from "cortex/ui/src/redux-store/api-sagas";
import type { ApiReducerAction } from "cortex/ui/src/redux-store/api-sagas/reducers";
import {
  type ById,
  deleteById,
  reduceById,
  reduceReducers,
} from "cortex/ui/src/redux-store/reducers";

import {
  CREATE_ALERT_V3_SUCCESS,
  DELETE_ALERT_V3_SUCCESS,
  EDIT_ALERT_V3_SUCCESS,
  LOAD_ALERTS_V3_FAILURE,
  LOAD_ALERTS_V3_SUCCESS,
} from "./actions";

interface AlertState extends Record<string, unknown> {
  byId?: ById<Alert>;
}

interface AlertAction extends ApiReducerAction {
  payload?: ApiReducerAction["payload"] & {
    data?: Alert;
  };
}

const apiAlertReducer = getApiReducer(
  LOAD_ALERTS_V3_SUCCESS,
  LOAD_ALERTS_V3_FAILURE,
);

function extraReducer(state: AlertState = {}, action: AlertAction) {
  const { type, payload } = action;
  const { data: alert } = payload || {};

  switch (type) {
    case CREATE_ALERT_V3_SUCCESS:
    case EDIT_ALERT_V3_SUCCESS:
      return {
        ...state,
        byId: alert ? reduceById(state.byId, [alert]) : state.byId,
      };
    case DELETE_ALERT_V3_SUCCESS:
      return {
        ...state,
        byId: alert
          ? deleteById(state.byId, [{ id: alert.id } as Alert])
          : state.byId,
      };
    default:
      return state;
  }
}

const alertV3Reducer = reduceReducers(apiAlertReducer, extraReducer);

export { alertV3Reducer, extraReducer };
